export const POINTSERV_STATUS_CODE_KEY = 'pointserv-status-code';
export const POINTSERV_VERIFICATION_OPTION = Object.freeze({
  PAYSTUB: 'paystub',
  TAX_RETURN: 'tax-return',
});
